import type { IOnboardingStep } from '../types';

import {
  ChartFunnelIcon,
  InventoryIcon,
  LightbulbIcon,
  StoreOnlineIcon,
  TargetIcon,
} from '@shopify/polaris-icons';
import { OnboardingUserRole, OnboardingUserScenario } from '../types';

export const ONBOARDING_USER_ROLE: Record<OnboardingUserRole, string> = {
  [OnboardingUserRole.STORE_OWNER]: 'Store owner',
  [OnboardingUserRole.ECOMMERCE_MANAGER]: 'E-commerce manager',
  [OnboardingUserRole.CRO_CONSULTANT]: 'CRO Consultant',
  [OnboardingUserRole.IN_HOUSE_MARKETER]: 'In-house Marketer',
  [OnboardingUserRole.OTHER]: 'Other',
};

export const ONBOARDING_USER_SCENARIO: Record<
  OnboardingUserScenario,
  {
    content: string;
    videoLink: string;
  }
> = {
  [OnboardingUserScenario.TWO_VERSIONS_LANDING_PAGE]: {
    content: 'Two versions of a Landing page',
    videoLink: 'https://www.youtube.com/embed/GEqybGYGYL0',
  },
  [OnboardingUserScenario.TWO_VERSIONS_ADVERTORIAL_PAGE]: {
    content: 'Two versions of a Advertorial page',
    videoLink: 'https://www.youtube.com/embed/AgaCRWEs4OA',
  },
  [OnboardingUserScenario.TWO_VERSIONS_HOME_PAGE]: {
    content: 'Two versions of a Home page',
    videoLink: 'https://www.youtube.com/embed/1yW9CztefDs',
  },
  [OnboardingUserScenario.SHOPIFY_PRODUCT_PAGE_VS_CUSTOM_PRODUCT_PAGE]: {
    content: 'Shopify Product page vs. Custom Product page',
    videoLink: 'https://www.youtube.com/embed/0tfzE_etufM',
  },
  [OnboardingUserScenario.LANDING_PAGE_VS_PRODUCT_PAGE]: {
    content: 'Landing page vs. Product page',
    videoLink: 'https://www.youtube.com/embed/VDbtYiG6ujQ',
  },
  [OnboardingUserScenario.DIFFERENT_LAYOUT_FOR_A_PRODUCT]: {
    content: 'Different layout for a product',
    videoLink: 'https://www.youtube.com/embed/rjifV6TZJu8',
  },
  [OnboardingUserScenario.TWO_DIFFERENT_FLOWS_LANDING_TO_PRODUCT_PAGE]: {
    content: 'Two different flows: Landing → Product page',
    videoLink: 'https://www.youtube.com/embed/r9ZZaF5gtMw',
  },
  [OnboardingUserScenario.NEW_VS_CURRENT_WEBSITE_DESIGN]: {
    content: 'New vs. current website design',
    videoLink: 'https://www.youtube.com/embed/jezhNPmRKK8',
  },
  [OnboardingUserScenario.NONE_OF_THESE_ABOVE]: {
    content: 'None of these above',
    videoLink: '',
  },
};

export const ONBOARDING_STEPS: IOnboardingStep[] = [
  {
    step: 0,
    title: 'How would you best describe yourself?',
    description: 'We want to ensure your experience is personalized.',
    isMultipleChoice: false,
    questionList: [
      {
        label: ONBOARDING_USER_ROLE[OnboardingUserRole.STORE_OWNER],
        value: OnboardingUserRole.STORE_OWNER,
        isSelected: false,
        icon: StoreOnlineIcon,
      },
      {
        label: ONBOARDING_USER_ROLE[OnboardingUserRole.ECOMMERCE_MANAGER],
        value: OnboardingUserRole.ECOMMERCE_MANAGER,
        isSelected: false,
        icon: LightbulbIcon,
      },
      {
        label: ONBOARDING_USER_ROLE[OnboardingUserRole.CRO_CONSULTANT],
        value: OnboardingUserRole.CRO_CONSULTANT,
        isSelected: false,
        icon: ChartFunnelIcon,
      },
      {
        label: ONBOARDING_USER_ROLE[OnboardingUserRole.OTHER],
        value: null,
        isSelected: false,
        isOther: true,
        icon: InventoryIcon,
      },
      {
        label: ONBOARDING_USER_ROLE[OnboardingUserRole.IN_HOUSE_MARKETER],
        value: OnboardingUserRole.IN_HOUSE_MARKETER,
        isSelected: false,
        icon: TargetIcon,
      },
    ],
  },
  {
    step: 1,
    title: 'Enable GemX Theme Helper to see your analytics',
    description: '',
    isMultipleChoice: false,
    isEnableThemeHelper: true,
    questionList: [],
  },
];

export const MAXIMUM_STACK = 3;

export const STEP_CLASS_NAMES = {
  isActive: 'onboarding-card-next onboarding-card-visible',
  isMiddle: 'onboarding-card-middle onboarding-card-middle-level',
  isBack: 'onboarding-card-back onboarding-card-back-level',
  isHidden: 'onboarding-card-exit',
};

export const GEMX_ONBOARDING_DATA_KEY = 'gemx:survey:onboarding';
